import { FC, Fragment } from 'react'
import classNames from 'classnames'
import { get } from '@/utils'

import { Form } from '@lounge-fe/ui-kit'
import { Text } from '@lounge-fe/ui-kit/src/components/Text'

import { SelectGroupProps } from './types'

const SelectGroup: FC<SelectGroupProps> = ({
  title,
  image,
  fields,
  className,
  showTitle = true,
  ...props
}) => {
  return (
    <div className={classNames(className, 'flex gap-4')} {...props}>
      {image && (
        <div className="bg-surface-primary-default h-min aspect-square flex-initial min-w-[114px]">
          {image}
        </div>
      )}
      <div className="flex flex-col flex-auto flex-1">
        {title && (
          <Text
            variant="body-md"
            className={classNames(
              'mb-3 font-regular leading-sm',
              !showTitle && 'invisible',
            )}
          >
            {title}
          </Text>
        )}
        <div
          className={classNames(
            'flex flex-col gap-3 [&_.select]:w-full',
            image && 'flex-col',
          )}
        >
          {fields.map((field, idx) => (
            <Fragment key={field.name}>
              {field.control === 'select' && (
                <Form.Select
                  name={field.name}
                  aria-label={
                    typeof field.label === 'string' ? field.label : undefined
                  }
                  options={(field?.options ?? []).map((option) => ({
                    ...option,
                    disabled: option.disabled && !field.isDisabledSelectable,
                    label: option.label,
                  }))}
                  placeholder={field.placeholder}
                />
              )}
              {field.control === 'choicechip' && (
                <Form.ChoiceChips
                  name={field.name}
                  aria-label={field.label}
                  className="grid grid-cols-[repeat(auto-fit,minmax(min(100%/2,max(40px,100%/9)),1fr))]"
                  options={(field?.options ?? []).map((option) => ({
                    ...option,
                    disabled: option.disabled && !field.isDisabledSelectable,
                    className: option.disabled
                      ? 'choice-chips__item--disabled'
                      : '',
                  }))}
                  preventEmpty
                />
              )}
              {get(field.errors, field.name)?.message && (
                <Text variant="body-sm" className="text-critical">
                  {String(get(field.errors, field.name)?.message)}
                </Text>
              )}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SelectGroup
